import { render, staticRenderFns } from "./screen-flow-step.vue?vue&type=template&id=21eb52d0&"
import script from "./screen-flow-step.vue?vue&type=script&lang=js&"
export * from "./screen-flow-step.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VStepperContent } from 'vuetify/lib/components/VStepper';
installComponents(component, {VStepperContent})
